import React from 'react'

import { Post } from '../../../types'
import { Avatar, MainEventImage } from '../../../components/Avatar'
import { salmon } from '../../../styles/themeColors'

export const getPostAvatar = ({ post }: { post: Post }): React.ReactElement => {
  const { userAlias, user, eventId } = post

  if (userAlias) {
    return (
      <MainEventImage
        eventId={eventId}
        size="40x40"
        defaultSize={40}
        defaultColor={salmon}
        className="user-profile rounded-circle"
      />
    )
  }

  return (
    <Avatar
      userId={user.id}
      size="40x40"
      defaultSize={40}
      defaultColor={salmon}
      className="rounded-circle"
    />
  )
}
